(function () {
    'use strict';

    angular.module('UndergroundWebApp').controller('BatteryTypeDetailsModalController', BatteryTypeDetailsModalController);

    BatteryTypeDetailsModalController.$inject = [
        '$q',
        '$scope',
        '$rootScope',
        '$windowInstance',
        'batteryTypeService',
        'formTypes',
        'currentFormType',
        'batteryType',
        '$translate'
    ];

    function BatteryTypeDetailsModalController(
        $q,
        $scope,
        $rootScope,
        $windowInstance,
        batteryTypeService,
        formTypes,
        currentFormType,
        batteryType,
        $translate
    ) {

        $scope.saveAndClose = saveAndClose;
        $scope.closeWindow = closeWindow;

        $scope.batteryType = batteryType != null ? { ...batteryType } : {};

        function save() {
            var deferred = $q.defer();

            $rootScope.$broadcast('showGlobalBusyIndicator', 'batteryTypeIndicator');

            var saveFunction = getSaveFunction(currentFormType);

            saveFunction($scope.batteryType)
                .then(result => deferred.resolve(result),
                    () => deferred.reject())
                .finally(() => $rootScope.$broadcast('hideBusyIndicator', 'batteryTypeIndicator'));

            return deferred.promise;
        }

        function getSaveFunction(currentFormType) {
            if (currentFormType === formTypes.edit) {
                return batteryTypeService.updateBatteryType.bind(batteryTypeService);
            }

            return batteryTypeService.addBatteryType.bind(batteryTypeService);
        }

        function saveAndClose(event) {
            event.preventDefault();

            if ($scope.validator.validate() && validateVoltageRange(event)) {
                save().then(function (result) {
                    $windowInstance.close(result);
                    $('#batteryTypeGrid').getKendoGrid().dataSource.read();
                });
            }
        }

        function validateVoltageRange(form) {      
            
            const min = Number(form.target[1].value);
            const max = Number(form.target[2].value);
            const capacity = Number(form.target[3].value);

            if (isNaN(min) || isNaN(max) || isNaN(capacity)) {
                $scope.voltageRangeErrorMessage = $translate.instant('ADMINISTRATION_BATTERY_TYPE_DIALOG_VOLTAGE_RANGE_TYPE_ERROR');
                return false;
            }
        
            if (min >= max) {
                $scope.voltageRangeErrorMessage = $translate.instant('ADMINISTRATION_BATTERY_TYPE_DIALOG_VOLTAGE_RANGE_ERROR');
                return false;
            }else{
                $scope.voltageRangeErrorMessage = "";
                return true;
            }            
        }


        function closeWindow(result) {
            $windowInstance.close(result);
        }
    }
})();